module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-geocoder-autocomplete__item">\n    <span class="b-geocoder-autocomplete__item-caption">' +
((__t = ( address )) == null ? '' : __t) +
'</span>\n</div>\n';

}
return __p
}